import { ApiEndpoints } from "./apiEndpoints";
import { fetchData, setHeaderOptions } from "./apiHelpers";
import { CreateVisitRow, UpdateVisitRow, VisitRow } from "./visit.type";

export const getVisit = async (visitId: string): Promise<VisitRow> => {
  const slug = ApiEndpoints.visit + `/${visitId}`;

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<VisitRow>(slug, options);
};

export const getVisits = async (userId?: string): Promise<VisitRow[]> => {
  const slug = ApiEndpoints.visit + (userId ? `/user/${userId}` : "");

  const options = await setHeaderOptions({ method: "GET" });

  return fetchData<VisitRow[]>(slug, options);
};

export const updateVisit = async (
  visit: UpdateVisitRow,
  patientUserId?: string
): Promise<VisitRow> => {
  let slug = ApiEndpoints.visit + "/" + visit.id;

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "PUT", body: visit });

  return fetchData<VisitRow>(slug, options);
};

export const createVisit = async (
  visit: CreateVisitRow,
  patientUserId?: string
): Promise<VisitRow> => {
  let slug = ApiEndpoints.visit + "/";

  if (patientUserId) {
    slug += `?patient_user_id=${patientUserId}`;
  }

  const options = await setHeaderOptions({ method: "POST", body: visit });

  return fetchData<VisitRow>(slug, options);
};
